import React from "react";
import CheckinCheckout from "../../components/eventLayout/checkinCheckout/CheckinCheckout";

const Registrations = () => {
  return <CheckinCheckout />;
};

export default Registrations;
